<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Codes</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="searchBy">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 160px;">
        <mat-label>Search By</mat-label>
        <mat-select class="site-filter" [(ngModel)]="filters.search_by" placeholder="Search By" name="searchBy">
          <mat-option value="id">Short Hash</mat-option>
          <mat-option value="name">Name</mat-option>
          <mat-option value="site">{{ utils.getLangTerm('parent-child-sites-combined.singular', 'Site') }}</mat-option>
          <mat-option value="account">Account</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="feature">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 200px;">
        <mat-label>Feature</mat-label>
        <mat-select [(ngModel)]="filters.feature" matTooltip="Filter codes by feature." name="feature">
          <mat-option value="">Any Feature</mat-option>
          <mat-option value="Access Control">Site Access Control</mat-option>
          <mat-option value="Asset">Asset</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="type">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 200px;">
        <mat-label>Type</mat-label>
        <mat-select [(ngModel)]="filters.type" matTooltip="Filter codes by type." name="type">
          <mat-option value="">Any Type</mat-option>
          <mat-option value="In/Out">In/Out</mat-option>
          <mat-option value="Details">Details</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="accounts">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 240px;" (click)="onSelectAccounts()">
        <mat-label>Accounts</mat-label>
        <input matInput readonly [value]="selectedAccountNames" placeholder="Filter by account" name="accounts"/>
        <button type="button" mat-icon-button matSuffix (click)="$event.stopPropagation(); onClearAccounts()" *ngIf="filters.selected_accounts.length" matTooltip="Clear accounts">
          <mat-icon>clear</mat-icon>
        </button>
        <mat-hint>Filter codes by the account that claimed them (find orphaned codes).</mat-hint>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="only_archived">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 240px;">
        <mat-label>Show Active or Archived Codes</mat-label>
        <mat-select [(ngModel)]="filters.only_archived" matTooltip="Filter codes by archival status." name="only_archived">
          <mat-option value="false">All Active</mat-option>
          <mat-option value="true">Only Archived</mat-option>
        </mat-select>
        <mat-hint>Use this to filter between active and archived codes.</mat-hint>
      </mat-form-field>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">

  <div class="p-2">
    <button type="button" mat-raised-button color="primary" (click)="onSaveAndClose()">
      <mat-icon>filter_list</mat-icon> Apply Filter
    </button>
  </div>

  <div class="p-2">
    <button type="button" mat-raised-button color="secondary" (click)="onClearAndClose()">
      <mat-icon> clear_all</mat-icon> Clear Filter
    </button>
  </div>

</mat-dialog-actions>
